import { collection } from "firebase/firestore";
import { db } from "src/features/firebase/firestore/utils";

const getAppVersionCollection = () => collection(db, `appVersion`);

export { getAppVersionCollection };
